import { isUndNullEmp, } from '../../helpers/settings';

export class GlobalFormats {
    constructor(
        _code = '',
        _id = '',
        _format = {
            date: {
                f1: '',
                f2: '',
                f3: '',
                f4: '',
                f5: '',
                f6: '',
                f7: '',
                f8: '',
                f9: '',
                f10: '',
                f11: '',
                f12: '',
                f13: '',
            },
            time: {
                f1: '',
                f2: '',
                f3: '',
                f4: '',
                picker: {
                    hhmm: '',
                    hhmmss: '',
                },
                type: 0,
            },
        },
        _numbers = {
            separators: {
                decimals: '',
                thousands: '',
            },
        },
        _recaptchat = {
            languageCode: '',
          },
    ) {
        this.code = _code;
        this.id = _id;
        this.format = _format;
        this.numbers = _numbers;
        this.recaptchat = _recaptchat;
    }

    static getClassName = () => {
        return 'GlobalFormat - class';
    }

    static class = (obj = Object) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName() })?.result) {
            return new GlobalFormats(
                obj.code,
                obj.id,
                obj.format,
                obj.numbers,
                obj.recaptchat,
            );
        } else {
            return new GlobalFormats();
        }
    }
}